interface State {
    visibleVersions: number[];
    showInterlinearNumbers: boolean;
    //searchAllVersions: boolean;
    //searchStems: boolean;
}

const initialState: State = {
    visibleVersions: [],
    showInterlinearNumbers: true,
    //searchAllVersions: false,
    //searchStems: false
};

enum ActionType {
    SET_VISIBLE_VERSIONS = 'SettingsState.SET_VISIBLE_VERSIONS',
    SET_SHOW_INTERLINEAR_NUMBERS = 'SettingsState.SET_SHOW_INTERLINEAR_NUMBERS',
    //SET_SEARCH_ALL_VERSIONS = 'SettingsState.SET_SEARCH_ALL_VERSIONS',
    //SET_SEARCH_STEMS = 'SettingsState.SET_SEARCH_STEMS'
}

interface SetVisibleVersionsAction {
    type: typeof ActionType.SET_VISIBLE_VERSIONS;
    versionIndexes: number[];
}

interface SetShowInterlinearNumbersAction {
    type: typeof ActionType.SET_SHOW_INTERLINEAR_NUMBERS;
    showInterlinearNumbers: boolean;
}

/*interface SetSearchAllVersionsAction {
    type: typeof ActionType.SET_SEARCH_ALL_VERSIONS;
    searchAllVersions: boolean;
}

interface SetSearchStemsAction {
    type: typeof ActionType.SET_SEARCH_STEMS;
    searchStems: boolean;
}*/

type Action =
    SetVisibleVersionsAction |
    SetShowInterlinearNumbersAction;
    //SetSearchAllVersionsAction |
    //SetSearchStemsAction;

export function setVisibleVersions(versionIndexes: number[]): SetVisibleVersionsAction {
    return {
        type: ActionType.SET_VISIBLE_VERSIONS,
        versionIndexes
    };
}

export function setShowInterlinearNumbers(showInterlinearNumbers: boolean): SetShowInterlinearNumbersAction {
    return {
        type: ActionType.SET_SHOW_INTERLINEAR_NUMBERS,
        showInterlinearNumbers
    };
}

/*export function setSearchAllVersions(searchAllVersions: boolean): SetSearchAllVersionsAction {
    return {
        type: ActionType.SET_SEARCH_ALL_VERSIONS,
        searchAllVersions
    };
}

export function setSearchStems(searchStems: boolean): SetSearchStemsAction {
    return {
        type: ActionType.SET_SEARCH_STEMS,
        searchStems
    };
}*/

export function reducer(state = initialState, action: Action): State {
    switch (action.type) {
        case ActionType.SET_VISIBLE_VERSIONS:
            return { ...state, visibleVersions: action.versionIndexes };
        case ActionType.SET_SHOW_INTERLINEAR_NUMBERS:
            return { ...state, showInterlinearNumbers: action.showInterlinearNumbers };
        /*case ActionType.SET_SEARCH_ALL_VERSIONS:
            return { ...state, searchAllVersions: action.searchAllVersions };
        case ActionType.SET_SEARCH_STEMS:
            return { ...state, searchStems: action.searchStems };*/
        default:
            return state;
    }
}
